import { useQuery } from '@tanstack/react-query';
import { dockerApi } from '../api/docker';

export function useDockerSummary() {
  return useQuery({
    queryKey: ['docker', 'summary'],
    queryFn: dockerApi.getSummary,
    refetchInterval: 20_000,
    staleTime: 10_000,
    retry: false,
  });
}
